<template>
    <div class="app-button-container">
        <router-link :aria-label="label"
                     :class="buttonClasses"
                     :tabindex="0"
                     :to="to"
                     class="app-button"
                     role="button"
                     v-if="to && enabled"
                     v-on:click.prevent="$emit('onClick')"
                     v-on:keyup.space="$emit('onClick')">
            <span class="app-button-text">
                <span aria-hidden="true" class="arrow-left" v-if="buttonType === 'back'">&lt;</span>
                <slot></slot>
                <span aria-hidden="true" class="arrow-right" v-if="buttonType === 'forward'">&gt;</span>
            </span>
        </router-link>
        <button :aria-label="label"
                :class="buttonClasses"
                :tabindex="0"
                class="app-button"
                role="button"
                v-else
                v-on:click.prevent="$emit('onClick')"
                v-on:keyup.space="$emit('onClick')">
            <span class="app-button-text">
                <span aria-hidden="true" class="arrow-left" v-if="buttonType === 'back'">&lt;</span>
                <slot></slot>
                <span aria-hidden="true" class="arrow-right" v-if="buttonType === 'forward'">&gt;</span>
            </span>
        </button>
    </div>
</template>

<script>
    export default {
        name: 'app-button',
        props: {
            to: {
                type: String
            },
            enabled: {
                type: Boolean,
                default: true
            },
            buttonType: {
                type: String,
                default: 'forward'
            }
        },
        computed: {
            label() {
                return '';
            },
            buttonClasses() {
                let classes = [
                    'app-button-' + this.buttonType
                ];

                classes.push('app-button-' + (this.enabled ? 'enabled' : 'disabled'));

                return classes;
            }
        }
    }
</script>
<style lang="less" scoped>
    @import "~@less/font-sizes.less";
    @import "~@less/mixins/mixins.less";

    .app-button-container {
        width: auto;
        display: inline-block;
    }

    @app-button-width: 167px;
    @app-button-height: 36px;

    .app-button {
        cursor: pointer;
        width: @app-button-width;
        height: @app-button-height;
        background: #ffffff;
        color: #000000;
        box-shadow: 0 3px 10px rgba(0, 0, 0, 0.3);
        border-radius: 5px;
        text-align: center;
        font-family: Roboto, sans-serif;
        font-size: @app-font-size-button;
        display: inline-block;
        font-weight: bold;
        transition: all 0.2s ease-in-out;
        outline: 0;
        border: 0;

        &.app-button-disabled {
            opacity: .3;
            cursor: not-allowed;

            &:hover {
                box-shadow: 0 3px 10px rgba(0, 0, 0, 0.3) !important;
            }
        }

        &:focus {
            outline: 3px solid #333333;
        }

        &:focus, &:hover {
            box-shadow: 0 3px 10px rgba(0, 0, 0, 0.6);
            text-decoration: none;
        }

        span {
            line-height: @app-button-height;
        }

        .arrow-left, .arrow-right {
            position: relative;
            top: 0px;
        }

        .arrow-left {
            padding-right: 8px;
        }

        .arrow-right {
            padding-left: 8px;
        }
    }

    .media-lg({ .app-button {
        width: @app-button-width * @size-percentage-lg;
        height: @app-button-height * @size-percentage-lg;

        span {
            line-height: @app-button-height * @size-percentage-lg;
        }
    } });

    .media-xl({ .app-button {
        width: @app-button-width * @size-percentage-xl;
        height: @app-button-height * @size-percentage-xl;

        span {
            line-height: @app-button-height * @size-percentage-xl;
            position: relative;
            top: -2px;
        }
    } });

    .media-xxl({ .app-button {
        width: @app-button-width * @size-percentage-xxl;
        height: @app-button-height * @size-percentage-xxl;

        span {
            line-height: @app-button-height * @size-percentage-xxl;
            position: relative;
            top: -4px;
        }
    } });
</style>